import React from 'react';

export default function ClockOpen(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
      <g id="Clock_Open" data-name="Clock Open">
        <circle id="path4155" cx="150" cy="150" r="134.99033" />
        <path d="M 150,150.18644 150,46.118644" id="path4157" />
        <path d="m 165,154 -94.067807,0" id="path4157-4" />
      </g>
    </svg>
  );
}
